import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxApprovals from "../../util/remote/ajaxApprovals";
import RequisitionApprovalDetailsModal from "./RequisitionApprovalDetailsModal";
const UserRequisitionApprovals = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [requisitions, setRequisitions] = useState([]);

  //fetching data
  const fetchRequisitionsList = async () => {
    setLoading(true);
    var data = {
      userID: userId,
    };
    setRequisitions([]);
    const server_response = await ajaxApprovals.fetchApprovals(data);
    setLoading(false);
    if (server_response.status === "OK") {
      setRequisitions(server_response.details);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchRequisitionsList();
  }, []);
  //view details modal
  const [view_details, setView_details] = useStateCallback(false);
  const handleView_details = (e, ID) => {
    // e.preventDefault();
    setView_details(false, () =>
      setView_details(
        <RequisitionApprovalDetailsModal
          ReqID={ID}
          funct={fetchRequisitionsList}
        />
      )
    );
  };
  return (
    <AppContainer title="Requisitions View">
      <div className="container-fluid">
        <Toaster />
        {view_details}
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/requsition/create")}
            >
              Create Requisition
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card card-dashboard-calendar pb-0">
              <label className="main-content-label mb-2 pt-1">
                Pending Requisitions Approvals
              </label>
              <span className="d-block tx-12 mb-2 text-muted">
                List of registered requisitions you need to approve
              </span>
              <table className="table table-striped table-hover table-responsive">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>Narration</th>
                    <th>Department</th>
                    <th>Est. Total</th>
                    <th>Approval Level</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(requisitions) &&
                    requisitions.map((req, key) => (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{req.naration}</td>
                        <td>{req.department}</td>
                        <td>{req.est_total}</td>
                        <td>{req.approval_level}</td>
                        <td>{req.status === "1" ? "Approved" : "Pending"}</td>
                        <td>{req.date_created}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={(e) => handleView_details(e, req.id)}
                          >
                            <i className="fa fa-eye" aria-hidden="true" />
                            details
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default UserRequisitionApprovals;
